// extracted by mini-css-extract-plugin
export default {"bigBox":"Bottom_bigBox__6B3O9"};